/**
 * Helper functions are inserted into all vue component instances.
 * They should be prefixed with a _ to differentiate from normal component methods.
 * This export can (and should if needed) be extended by other files for organization.
 */
export default {

};
